import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";

@Component({
  selector: 'vbn-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  language = localStorage.getItem("vbn-language");

  constructor(private translate: TranslateService) { }

  ngOnInit() {
     this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.language = localStorage.getItem("vbn-language");
    });
  }

}
